export default {
  profile: 'Información de perfil',
  welcome: 'Bienvenido',
  enter: 'Ingrese Ingrese su correo electrónico y contraseña para iniciar sesión',
  required: 'email es un campo obligatorio',
  pass: 'Contraseña debe tener al menos 8 caracteres',
  remindme: 'Recuérdame',
  login: 'Iniciar Sesión',
  loggingIn: 'Ingresando...',
  logOut: 'Cerrar Sesión',
  signUp: 'Regístrate',
  alert: 'Usuario o contraseña incorrectos!',
  no_account: '¿No tienes cuenta?',
  already_account: '¿Ya tienes cuenta?',
  upss: 'Upss!',
  create_new_account: 'Ingresa tus datos',
  create_account: 'Regístrate',
  go_back: 'Volver',
  forbidden: 'Lo sentimos, su acceso está denegado por razones de seguridad de nuestro servidor y también de nuestros datos sensibles.\n\n Por favor inicia sesión con otra cuenta',
  fields: {
    name: 'Nombre',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirm_password: 'Confirma tu contraseña',
    phone: 'Teléfono',
    phone2: 'Teléfono 2',
    roles: 'Roles',
    admin: 'Administrador',
    operator: 'Operador',
    superadmin: 'Super Administrador',
    role: 'Role',
    device: 'Dispositivo',
    status: 'Status'
  },
  platform_settings: 'Configuraciones',
  forms: {
    edit: 'Editar información del usuario',
    edit_password: 'Ingresa tu nueva contraseña',
    upload: 'Subir foto de perfil',
    select_img: 'Seleccione una imagen del archivo'
  },
  loginErrors: {
    invalidCredentials: {
      title: 'No pudimos iniciar sesión',
      message: 'Verifica tu correo y contraseña e inténtalo de nuevo.'
    },
    missingProfile: {
      title: 'Tu cuenta aún no está lista',
      message: 'La autenticación fue exitosa, pero tu usuario todavía no existe o no está habilitado en el panel administrativo.'
    },
    serverError: {
      title: 'No pudimos completar el acceso',
      message: 'Ocurrió un problema cargando tu perfil. Inténtalo de nuevo en unos segundos.'
    }
  },
  messages: {
    enabled: 'El usuario ha sido habilitado!',
    disabled: 'El usuario ha sido inhabilitado!',
    permissions: 'No tienes permisos para realizar esta acción!'
  }
}
